import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import moment from 'moment'
import Button from 'src/Components/shared/Button'
import { Text, Logo, ExternalLinkButton } from 'src/Components'
import { isIFramed } from 'src/helpers/browser'

import classNames from 'classnames'
import { TOS_LINK, PRIVACY_LINK } from 'src/constants/navigation'
import styles from './FooterText.module.scss'
import { Link } from 'react-router-dom'

const currentYear = moment().format('YYYY')

const iFrameProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
}

const propTypes = {
  className: PropTypes.string,
}

const linkProps = () => (isIFramed() ? iFrameProps : {})

const FooterText = ({ className }) => (
  <div className={className} data-qa='homebot-disclaimer'>
    <Text
      className={styles.text}
      paragraph
      size='xs'
      variant='neutralCool'
      variantCount='700'
    >
      <FormattedMessage
        id='Footer.copyright'
        defaultMessage='© {currentYear} Homebot Inc. All rights reserved.'
        values={{ currentYear }}
      />
      <br />
      <FormattedMessage
        id='Footer.trademark'
        defaultMessage='Homebot™ and the Homebot logo are trademarks of Homebot Inc.'
      />{' '}
      <FormattedMessage
        id='Footer.unaffiated'
        defaultMessage='Homebot is an unaffiliated business party. Homebot is a service purchased by us to provide to you, our customer.'
      />
    </Text>
    <Logo className={classNames(styles.logo, styles.forceShow)} />
    <Text element='div' size='xs' variant='neutralCool' variantCount='900'>
      <div>
        <ExternalLinkButton href={PRIVACY_LINK} minimal>
          <FormattedMessage
            id='Footer.link.privacyPolicy'
            defaultMessage='Privacy Policy'
          />
        </ExternalLinkButton>
      </div>

      <div>
        <ExternalLinkButton href={TOS_LINK} minimal>
          <FormattedMessage
            id='Footer.link.terms'
            defaultMessage='Terms of Service'
          />
        </ExternalLinkButton>
      </div>
    </Text>
  </div>
)

FooterText.propTypes = propTypes

export default FooterText
